import * as React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import TextField from '@mui/material/TextField';
import InputLabel  from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  },
);

export class FormattedInputProps {
  value: any;
  onChange: any;
  onBlur?: any;
  helpText?: string;
  label: string;
  name: string;
  error?: string;
  ref?: any;
}

export const FormattedInput: React.FunctionComponent<FormattedInputProps> = ({ value, onChange, onBlur, helpText, label, name, error, ref }) => {

  return (<>
      <InputLabel sx={{fontSize: 15, fontWeight: 600}}>{label}</InputLabel>
      <TextField
        error={error?true:false}
        name={name}
        fullWidth
        ref={ref}
        sx={{ mx: 0, mt: "2px", mb: error?"8px":"31px" }}
        value={value}
        helperText={error}
        onChange={onChange}
        onBlur={onBlur}
        InputProps={{
          inputComponent: NumericFormatCustom as any,
          startAdornment: (
            <InputAdornment position="start">
              $
            </InputAdornment>
          )
        }}
      />
  </>);
}